import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Inter, bundled and served from this site (the policy allows no font from elsewhere).
import '@fontsource-variable/inter'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
